module.exports = __webpack_public_path__ + "static/media/oasis.93421f03.svg";